import type { UpdateProfileInput } from '@noconflict/contracts';
import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';

export type Values = UpdateProfileInput;

const name = (required: 'firstNameRequired' | 'lastNameRequired') =>
  z.string().trim().min(1, validationMessage(required)).max(80, validationMessage('nameMax'));

/** Same rules as the contract's `updateProfileInputSchema`, with messages from the catalogue. */
export const schema: z.ZodType<Values, Values> = z.object({
  firstName: name('firstNameRequired'),
  lastName: name('lastNameRequired'),
});
